import React, { useEffect } from "react";
import { Grid, InputAdornment, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useEquipment, useUser } from "@services/servicesGenericsTables";
import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import useFilterSamplingProcedure from "@app/hooks/useFilterSamplingProcedure";
import useAuth from "@app/context/AuthContext";
import { formatDateOrNow } from "@app/utils/formatDate";

const Chipping = () => {
  const form = useFormContext();
  const filterSamplingProcedureList = useFilterSamplingProcedure("VIRU");
  const { equipmentList } = useEquipment();
  const { userList } = useUser();
  const { user } = useAuth();

  useEffect(() => {
    if (!form.getValues("processing_analyst_chipping")) {
      form.setValue("processing_analyst_chipping", user);
    }

    if (!form.getValues("processing_date_time_chipping")) {
      form.setValue("processing_date_time_chipping", formatDateOrNow());
    }

    if (!form.getValues("processing_procedure_chipping")) {
      form.setValue(
        "processing_procedure_chipping",
        filterSamplingProcedureList[0] || undefined
      );
    }
  }, []);

  return (
    <>
      <Grid item xs={12} my={2}>
        <Typography variant="tagText">{"Virutado"}</Typography>
      </Grid>
      <ResponsiveFormContainer columns={5} mt={1}>
        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_analyst_chipping"))}
          name="processing_analyst_chipping"
          options={userList}
          label="Seleccione un analista"
          getOptionLabel={(option) => option.username || ""}
          validation={{ required: "El analista es requerido" }}
        />
        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_procedure_chipping"))}
          name="processing_procedure_chipping"
          options={filterSamplingProcedureList}
          label="Procedimiento MLPMA"
          getOptionLabel={(option) => `${option.numop}` || ""}
          validation={{
            required:
              filterSamplingProcedureList.length > 0
                ? "El procedimiento MLPMA es requerido"
                : false,
          }}
        />
        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_equipment_chipping"))}
          name="processing_equipment_chipping"
          options={equipmentList}
          label="Seleccione un Equipo"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}` || ""
          }
          validation={{ required: "El equipo es requerido" }}
          multiple={true}
        />
        <MDatePicker
          name="processing_date_time_chipping"
          pickerType="datetime"
          label="Fecha y hora Inicio"
          validation={{ required: "La fecha y hora de inicio es requerida" }}
        />

        <MTextField
          key={JSON.stringify(form.getValues("sample_quantity_chipping"))}
          name="sample_quantity_chipping"
          placeholder="Cantidad muestra"
          label="Cantidad muestra"
          type="number"
          fullWidth
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default Chipping;
